const intToString = (value, placeholder = '') => {
    if (!value) return placeholder;
    if (value < 100) return value;
    let convertedValue = Number(value);
  
    const suffixes = ['', 'K', 'M', 'B', 'T'];
    let magnitude = 0;
  
    while (convertedValue >= 1000 && magnitude < suffixes.length - 1) {
      convertedValue /= 1000;
      magnitude++;
    }
  
    const formattedNumber = convertedValue.toLocaleString('en-US', { maximumFractionDigits: 1 });
    const suffix = suffixes[magnitude];
  
    return formattedNumber + suffix;
}

// Round numbers, like 0.000134 => 0.00013, 0.00468 => 0.0047 and so on
const roundOffNumber = (value, numberAfterComma = 2) => {
    if (value === 0) return value;
    if (value < 1 && value > 0) {
        const numberString = value.toString();
        const decimalPosition = numberString.indexOf('.');
        let nonZeroIndex = decimalPosition + 1;

        if (numberString.charAt(nonZeroIndex) === '0') {
        while (nonZeroIndex < numberString.length && numberString[nonZeroIndex] === '0') {
            nonZeroIndex++;
        }

        const replaced = value.toFixed(nonZeroIndex + numberAfterComma - 2); // dot sign + first non zero number

        return Number(replaced);
        } else {
        const divider = Number('1'.padEnd(Math.max(numberAfterComma, 1) + 1, '0'));
        return Math.round((value + Number.EPSILON) * divider) / divider;
        }
    }
    const divider = Number('1'.padEnd(numberAfterComma + 1, '0'));
    return Math.round((value + Number.EPSILON) * divider) / divider;
};

$(document).on('ready', function(){
    const visualizationCanvasElements = document.querySelectorAll('.visualization canvas') || [];
    if (!!visualizationCanvasElements.length) {
        visualizationCanvasElements.forEach(canvasElement => {
            const trendGraph = JSON.parse(canvasElement.dataset.chartSource);
            const usePercentile = !!Number(canvasElement.dataset.chartPercentile);
            const useCurrency = !!Number(canvasElement.dataset.chartCurrency);
            const chartType = canvasElement.dataset.chartType || 'line';
            const chartFill = canvasElement.dataset.chartFill !== undefined ? !!Number(canvasElement.dataset.chartFill) : true;
            const chartColor = canvasElement.dataset.chartColor || '#53049C';

            new Chart(canvasElement, {
                type: chartType,
                data: {
                    labels: trendGraph.map((trendLine) => new Date(trendLine.date || '').toLocaleDateString()),
                    datasets: [{
                        data: trendGraph.map((trendLine) => trendLine.relativeFrequency || 0),
                        borderWidth: 1,
                        fill: chartFill,
                        borderColor: chartColor,
                        backgroundColor: chartColor,
                        pointRadius: 0,
                        tension: 0.3,
                        hoverRadius: 0,
                        hoverBorderWidth: 0 ,
                    }]
                },
                options: {
                    interaction: {
                        intersect: false,
                        mode: 'index',
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            callbacks: {
                                label: (val) => `${useCurrency ? '$': ''}${intToString(roundOffNumber(val.raw), 0)}${usePercentile ? '%': ''}`,
                            }
                        }
                    },
                    scales: {
                        x: {
                            ticks: {
                                precision: 0,
                                stepSize: 1,
                                autoSkip: true,
                                minRotation: 0,
                                maxTicksLimit: 7,
                            },
                        grid: {
                            display: false,
                        }
                        },
                        y: {
                            beginAtZero: true,
                            ticks: {
                                callback: (val) => {
                                    return `${useCurrency ? '$': ''}${intToString(roundOffNumber(val, 2), 0)}${usePercentile ? '%': ''}`;
                                },
                            },
                            grid: {
                            display: false,
                        }
                        }
                    }
                }
            });
        })
    };
});

// Smooth scrolling by clicking on anchor link
const header = document.querySelector('#top-bar-menu');
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        // Scroll to the top in case it is the first element in table of content
        const target = e.currentTarget.getAttribute('href') === '#introduction' ? null : document.querySelector(e.currentTarget.getAttribute('href'));
        const targetPosition = target ? target.getBoundingClientRect().top + window.scrollY - ((header || {}).clientHeight || 0) + 3 : 0;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    });
});

function throttle(fn, wait) {
    var time = Date.now();
    return function () {
      if (time + wait - Date.now() < 0) {
        fn();
        time = Date.now();
      }
    };
}

var addClassOnScroll = function () {
    var windowTop = $(window).scrollTop();
    $(".content-section-js").each(function (index, elem) {
        var offsetTop = $(elem).offset().top;
        var outerHeight = $(this).outerHeight(true);

        if (windowTop > offsetTop - 120 && windowTop < offsetTop + outerHeight) {
            var elemId = $(elem).attr("id");
            $(".table-of-content li a.active").removeClass("active");
            $(".table-of-content a[href='#" + elemId + "']").addClass("active");
        }
    });
};

$(document).ready(function () { 
    window.addEventListener("scroll", throttle(addClassOnScroll, 100));

    requestAnimationFrame(addClassOnScroll);
});
